import { createContext, type ReactNode, useContext, useMemo } from 'react';

const DEFAULT_ORCHESTRATOR_NAME = 'pay-group-payments-component-orchestrator';

interface PaySuiteConfig {
  orchestratorName: string;
}

const PaySuiteConfigContext = createContext<PaySuiteConfig>({
  orchestratorName: DEFAULT_ORCHESTRATOR_NAME,
});

export function usePaySuiteConfig(): PaySuiteConfig {
  return useContext(PaySuiteConfigContext);
}

interface PaySuiteConfigProviderProps {
  orchestratorName?: string;
  children: ReactNode;
}

export function PaySuiteConfigProvider({
  orchestratorName,
  children,
}: Readonly<PaySuiteConfigProviderProps>): React.ReactElement {
  const value = useMemo<PaySuiteConfig>(
    () => ({ orchestratorName: orchestratorName ?? DEFAULT_ORCHESTRATOR_NAME }),
    [orchestratorName],
  );

  return <PaySuiteConfigContext.Provider value={value}>{children}</PaySuiteConfigContext.Provider>;
}
